export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1600275669283-4bf2bb8a990c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGRlc2slMjB3YXJtJTIwYmVpZ2UlMjBvZmZpY2UlMjBwbGFudHN8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  svc_hr:
    "https://images.unsplash.com/photo-1653669486653-5f13827ea0ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHx3YXJtJTIwb2ZmaWNlJTIwbWVldGluZyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbm90ZWJvb2t8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  svc_process:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx3YXJtJTIwb2ZmaWNlJTIwbWVldGluZyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbm90ZWJvb2t8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  svc_strategy:
    "https://images.unsplash.com/photo-1605256585681-455837661b18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx3YXJtJTIwb2ZmaWNlJTIwbWVldGluZyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbm90ZWJvb2t8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  svc_data:
    "https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjBhbmFseXRpY3MlMjBjaGFydHMlMjBvZmZpY2V8ZW58MHx8fHwxNzg4ODY3MDA5fDA&ixlib=rb-4.1.0&q=85",
  svc_change:
    "https://images.unsplash.com/photo-1623652554515-91c833e3080e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx3b3Jrc2hvcCUyMHN0aWNreSUyMG5vdGVzJTIwdGVhbXxlbnwwfHx8fDE3ODg4NjcwMDl8MA&ixlib=rb-4.1.0&q=85",
  svc_brand:
    "https://images.unsplash.com/photo-1716471330463-f475b00f0506?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwzfHxkZXNpZ24lMjBzd2F0Y2hlcyUyMG1vb2Rib2FyZCUyMGRlc2t8ZW58MHx8fHwxNzg4ODY3MDA5fDA&ixlib=rb-4.1.0&q=85",
  svc_content:
    "https://images.unsplash.com/photo-1585832770485-e68a5dbfad52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjB3cml0aW5nJTIwbm90ZWJvb2slMjBjb2ZmZWUlMjB3YXJtJTIwZGVza3xlbnwwfHx8fDE3ODg4NjcwMTd8MA&ixlib=rb-4.1.0&q=85",
  svc_admin:
    "https://images.unsplash.com/photo-1618381801643-3d253a63a386?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwyfHx0aWR5JTIwb2ZmaWNlJTIwZGVzayUyMHN0YXRpb25lcnklMjBtaW5pbWFsfGVufDB8fHx8MTc4ODg2NzAxN3ww&ixlib=rb-4.1.0&q=85",
  svc_digital:
    "https://images.unsplash.com/photo-1776278806688-64ef6a7e2cc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHx3ZWIlMjBkZXNpZ24lMjBzY3JlZW4lMjBtb2Rlcm58ZW58MHx8fHwxNzg4ODY3MDI1fDA&ixlib=rb-4.1.0&q=85",
  svc_tech:
    "https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxoYW5kcyUyMHR5cGluZyUyMGxhcHRvcCUyMHRlY2glMjB3YXJtfGVufDB8fHx8MTc4ODg2NzAzMnww&ixlib=rb-4.1.0&q=85",
  svc_training:
    "https://images.unsplash.com/photo-1776039230119-6e69e241512d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwcmVzZW50YXRpb24lMjB0cmFpbmluZyUyMHJvb20lMjBwcmVzZW50ZXJ8ZW58MHx8fHwxNzg4ODY3MDI1fDA&ixlib=rb-4.1.0&q=85",
  svc_fractional:
    "https://images.unsplash.com/photo-1616587896649-79b16d8b173d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHx2aWRlbyUyMGNhbGwlMjBsYXB0b3AlMjBob21lJTIwb2ZmaWNlfGVufDB8fHx8MTc4ODg2NzAyNXww&ixlib=rb-4.1.0&q=85",
  product_docs:
    "https://images.unsplash.com/photo-1676287569661-5f2836a91c64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx3YXJtJTIwb2ZmaWNlJTIwbWVldGluZyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbm90ZWJvb2t8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  product_recruitment:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx3YXJtJTIwb2ZmaWNlJTIwbWVldGluZyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbm90ZWJvb2t8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
  blog_reading:
    "https://images.unsplash.com/photo-1600275669283-4bf2bb8a990c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw3fHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGRlc2slMjB3YXJtJTIwYmVpZ2UlMjBvZmZpY2UlMjBwbGFudHN8ZW58MHx8fHwxNzg4ODYwOTU4fDA&ixlib=rb-4.1.0&q=85",
};

export const CONTACT_EMAIL = "bhaktinarang@kikiservices.co.in";
export const WHATSAPP_NUMBER = "919867982112";
export const BLOG_URL = "https://hrmexpress.wordpress.com";

export const SERVICES = [
  {
    id: "01",
    slug: "hr-and-people",
    tag: "People",
    title: "HR & People",
    line: "HR, payroll, compliance & people operations, structured end-to-end.",
    image: "svc_hr",
    icon: "Users",
    groups: [
      {
        name: "Recruitment & Talent Acquisition",
        items: [
          { n: "Recruitment Process Setup", p: "₹10,000–30,000", s: "Hiring workflow, approvals, sourcing channels, interview stages, evaluation process, tracker and reporting." },
          { n: "Recruitment Support", p: "8–12% annual CTC or fixed fee", s: "JD creation, sourcing, screening, interview coordination, candidate communication, offer and joining follow-up." },
          { n: "Candidate Sourcing & Screening", p: "₹5,000–20,000 / requirement", s: "Source candidates, shortlist, screening calls, candidate database and screening notes." },
          { n: "Bulk Hiring Support", p: "₹25,000+ project", s: "Hiring plan, sourcing, screening, interview coordination, offer and joining tracking." },
          { n: "Executive Hiring Support", p: "8–15% annual CTC", s: "Targeted sourcing, screening, interview coordination, references and offer support." },
          { n: "Job Description Creation", p: "₹1,000–3,000 / JD", s: "Role purpose, responsibilities, qualifications, skills, reporting line and KPI outline." },
          { n: "Recruitment MIS & Dashboard", p: "₹5,000–20,000", s: "Pipeline, source, ageing, interviews, offers, joining and hiring KPI reporting." },
        ],
      },
      {
        name: "Payroll & Salary Administration",
        items: [
          { n: "Monthly Payroll Processing", p: "₹5,000–15,000 / month (up to 25 employees)", s: "Attendance, leave, overtime, incentives, variable pay, salary calculation, payslips, register, bank statement and reports." },
          { n: "Payroll Setup", p: "₹10,000–40,000", s: "Payroll calendar, salary heads, earnings/deductions, statutory settings, employee master, testing and approval workflow." },
          { n: "Payroll Reconciliation", p: "₹5,000–15,000 / month", s: "Payroll versus attendance, bank and accounting reconciliation; variance analysis and correction." },
          { n: "Payslip Generation", p: "₹30–50 / employee", s: "Generate, verify, distribute, correct and archive payslips." },
          { n: "Full & Final Settlement", p: "₹500–1,500 / employee", s: "Exit checklist, salary, leave encashment, notice pay, recoveries, bonus, gratuity support, tax adjustment and statement." },
          { n: "Payroll Audit", p: "₹15,000–50,000", s: "Payroll process review, sampling, error/risk analysis, reconciliation, controls and audit report." },
          { n: "Payroll SOP Creation", p: "₹15,000–40,000", s: "Workflow, calendar, roles, approvals, checklist, controls, escalation, SOP and training." },
          { n: "Excel Payroll Automation", p: "₹15,000–50,000", s: "Payroll workbook, formulas, attendance/leave integration, payslip, MIS and dashboard automation." },
        ],
      },
      {
        name: "Compensation & Benefits",
        items: [
          { n: "CTC & Salary Structure Design", p: "₹1,000–3,000 / employee", s: "CTC breakup, basic, HRA, allowances, employer contributions, variable pay, gratuity and cost analysis." },
          { n: "Compensation Benchmarking", p: "₹15,000–50,000", s: "Market research, internal parity, salary comparison, grades and increment recommendations." },
          { n: "Salary Review & Increment Structure", p: "₹10,000–35,000", s: "Salary analysis, increment matrix, budget impact and recommendations." },
          { n: "Variable Pay & Incentive Structure", p: "₹10,000–40,000", s: "Eligibility, targets, slabs, payout logic, governance and calculator/template." },
          { n: "Benefits Structure Review", p: "₹10,000–35,000", s: "Benefits inventory, eligibility, cost and employee-value review." },
        ],
      },
      {
        name: "HR Operations",
        items: [
          { n: "Employee Data Setup", p: "₹3,000–10,000", s: "Employee master, personal/contact data, bank/PAN/UAN/ESIC, department, designation, salary, leave and documents." },
          { n: "Joining & Onboarding Process", p: "₹8,000–25,000", s: "Pre-joining checklist, documents, induction, access, policy acknowledgement and tracker." },
          { n: "Attendance & Leave Management", p: "₹3,000–8,000 / month", s: "Attendance, shifts, late/early reports, leave, holidays, overtime, corrections and reports." },
          { n: "Employee Lifecycle Management", p: "₹10,000–35,000 / month", s: "Joining, confirmation, transfers, promotions, increments, records, changes and exits." },
          { n: "Exit Management", p: "₹5,000–15,000 / project", s: "Resignation, clearance, exit interview, asset recovery, F&F coordination and exit documentation." },
        ],
      },
      {
        name: "HRMS & HR Technology",
        items: [
          { n: "HRMS Selection & Advisory", p: "₹10,000–30,000", s: "Requirements, vendor comparison, feature/cost review and recommendation." },
          { n: "HRMS Implementation", p: "₹20,000–75,000+", s: "Company setup, departments, policies, employee import, roles, workflows, testing and go-live." },
          { n: "HRMS Configuration & Administration", p: "₹10,000–40,000 / project", s: "Configuration, employee updates, permissions, workflows, reports and master maintenance." },
          { n: "HRMS Training", p: "₹5,000–20,000 / program", s: "Admin/employee training, process walkthrough, guides and Q&A." },
        ],
      },
      {
        name: "Statutory & HR Compliance",
        items: [
          { n: "PF Registration Support", p: "₹7,500–15,000", s: "Registration support, establishment details, UAN mapping, KYC and documentation." },
          { n: "ESI Registration Support", p: "₹7,500–15,000", s: "Employer/employee registration, insurance/family details, portal and documentation." },
          { n: "Professional Tax Registration", p: "₹3,000–8,000", s: "Registration application support, state requirements and certificate coordination." },
          { n: "Monthly PF & ESI Filing Support", p: "₹3,000–8,000 / month", s: "Wage verification, contribution calculation, ECR/return, challan, upload and records." },
          { n: "Salary TDS Processing", p: "₹3,000–10,000 / month", s: "Declarations, investment proofs, monthly TDS, adjustments, challan/return and Form 16 support." },
          { n: "Form 16 Preparation Support", p: "₹200–500 / employee", s: "Salary/tax reconciliation, generation support, verification and distribution." },
          { n: "Labour Law Compliance Review", p: "₹3,000–10,000", s: "Compliance checklist, registers, notices, documentation, calendar and inspection readiness." },
          { n: "HR Compliance Audit", p: "₹25,000–75,000", s: "Employee files, payroll, attendance, leave, statutory records, contracts, gap report and corrective plan." },
        ],
      },
      {
        name: "HR Policies & Employee Documentation",
        items: [
          { n: "HR Policy Manual", p: "₹20,000–60,000", s: "Leave, attendance, conduct, working hours, travel, expenses, discipline, WFH, exit and agreed policies." },
          { n: "Employee Handbook", p: "₹15,000–40,000", s: "Company overview, policies, benefits, conduct, procedures, grievance route and FAQ." },
          { n: "Employment Letter Templates", p: "₹5,000–15,000", s: "Offer, appointment, confirmation, increment, promotion, transfer, resignation, relieving and experience formats." },
          { n: "HR Forms & Document Pack", p: "₹10,000–25,000", s: "Joining, exit, leave, reimbursement, confirmation, warning, promotion, transfer and employee-record forms." },
          { n: "Leave Policy Design", p: "₹8,000–20,000", s: "Leave types, eligibility, accrual, carry-forward, encashment, approval and documentation." },
        ],
      },
      {
        name: "Performance Management",
        items: [
          { n: "Performance Management System", p: "₹30,000–1,50,000", s: "Cycle, goals, KRA/KPI, appraisal, ratings, review workflow, PIP and manager guidance." },
          { n: "KRA / KPI Framework", p: "₹10,000–40,000", s: "Role analysis, measurable KRAs/KPIs, targets, weightages and review framework." },
          { n: "Performance Improvement Plan", p: "₹5,000–15,000 / employee", s: "Performance gaps, objectives, milestones, review dates, responsibilities and documentation." },
        ],
      },
      {
        name: "HR Analytics & Reporting",
        items: [
          { n: "HR MIS", p: "₹5,000–20,000 / month", s: "Headcount, recruitment, attrition, attendance, leave, payroll, employee movement and monthly reporting." },
          { n: "HR Dashboard", p: "₹20,000–60,000", s: "Headcount, attrition, recruitment, leave, attendance, payroll/cost and KPI visualisation." },
        ],
      },
    ],
  },
  {
    id: "02",
    slug: "business-process-consulting",
    tag: "Process",
    title: "Business Process Consulting",
    line: "Assess, design, document and automate your core processes.",
    image: "svc_process",
    icon: "Workflow",
    groups: [
      {
        name: "Process Assessment",
        items: [
          { n: "Current-State Process Review", p: "₹15,000–50,000", s: "Stakeholder discussions, workflow review, pain points, bottlenecks and observations." },
          { n: "Process Mapping", p: "₹5,000–20,000 / process", s: "Steps, inputs/outputs, roles, systems, decisions, handoffs and controls." },
          { n: "Process Gap Analysis", p: "₹15,000–50,000", s: "Current versus desired state, gaps, risks, root causes and recommendations." },
          { n: "Process Audit", p: "₹20,000–75,000", s: "Process and control review, exceptions, evidence, findings and action plan." },
        ],
      },
      {
        name: "Process Design & Optimisation",
        items: [
          { n: "New Process Design", p: "₹20,000–75,000", s: "Requirements, future-state workflow, roles, controls, approvals, KPIs and roadmap." },
          { n: "Process Redesign & Optimisation", p: "₹20,000–75,000", s: "Pain points, simplification, standardisation, redesign, controls and rollout." },
          { n: "Workflow & Approval Design", p: "₹10,000–40,000", s: "Approval levels, delegation, escalation, turnaround and workflow documentation." },
        ],
      },
      {
        name: "Process Documentation",
        items: [
          { n: "Process Manual", p: "₹15,000–50,000", s: "Purpose, scope, roles, steps, controls, forms, exceptions and review cycle." },
          { n: "RACI / Responsibility Matrix", p: "₹5,000–15,000", s: "Responsible, accountable, consulted and informed mapping." },
          { n: "Process Checklists & Work Instructions", p: "₹3,000–15,000", s: "Task checklists, work instructions, quality checks and escalation." },
        ],
      },
      {
        name: "Process Automation",
        items: [
          { n: "Process Automation Assessment", p: "₹15,000–50,000", s: "Manual-work analysis, feasibility, prioritisation, benefits and roadmap." },
          { n: "Automation Roadmap", p: "₹20,000–75,000", s: "Prioritised automation backlog, tools, dependencies, phases and governance." },
        ],
      },
    ],
  },
  {
    id: "03",
    slug: "business-and-management-consulting",
    tag: "Strategy",
    title: "Business & Management Consulting",
    line: "Health checks, structure, planning and improvement for growth.",
    image: "svc_strategy",
    icon: "Target",
    groups: [
      {
        name: "Business Assessment",
        items: [
          { n: "Business Health Assessment", p: "₹20,000–75,000", s: "Business, operations, people, process, customer, cost and risk review." },
          { n: "Operational Review", p: "₹20,000–75,000", s: "Operating activities, bottlenecks, resources, controls, service levels and improvement plan." },
        ],
      },
      {
        name: "Organisation & Structure",
        items: [
          { n: "Organisation Structure Design", p: "₹15,000–50,000", s: "Departments, reporting lines, roles, spans and structure recommendations." },
          { n: "Role & Responsibility Mapping", p: "₹10,000–35,000", s: "Role descriptions, responsibilities, ownership, handoffs and accountability." },
          { n: "RACI / Approval Matrix", p: "₹5,000–20,000", s: "Decision rights, approval levels, accountability and escalation." },
        ],
      },
      {
        name: "Business Planning",
        items: [
          { n: "Business Planning Support", p: "₹20,000–75,000", s: "Goals, priorities, action plans, resources, timelines and KPIs." },
          { n: "Business Growth Planner", p: "₹15,000–50,000", s: "Growth objectives, customer/marketing/operations actions, milestones and metrics." },
        ],
      },
      {
        name: "Business Improvement",
        items: [
          { n: "Cost Optimisation Review", p: "₹20,000–75,000", s: "Cost mapping, inefficiencies, savings opportunities and action plan." },
          { n: "Operational Efficiency Review", p: "₹20,000–75,000", s: "Productivity, workflow, resource use, turnaround and improvement recommendations." },
        ],
      },
    ],
  },
  {
    id: "04",
    slug: "data-analysis-mis-and-bi",
    tag: "Insight",
    title: "Data Analysis, MIS & BI",
    line: "Turn scattered data into clean dashboards and decisions.",
    image: "svc_data",
    icon: "BarChart3",
    groups: [
      {
        name: "Data Management",
        items: [
          { n: "Data Collection & Structuring", p: "₹5,000–25,000", s: "Collect, organise, standardise, classify and structure data." },
          { n: "Data Cleaning & Validation", p: "₹5,000–30,000", s: "Duplicates, missing values, formats, validation rules and quality checks." },
          { n: "Data Consolidation", p: "₹7,500–35,000", s: "Combine sources, standardise fields, reconcile records and create master dataset." },
        ],
      },
      {
        name: "Excel & Spreadsheet Services",
        items: [
          { n: "Advanced Excel Analysis", p: "₹5,000–30,000", s: "Formulas, pivots, lookups, analysis, summaries and charts." },
          { n: "Excel Automation", p: "₹15,000–50,000", s: "Automated calculations, templates, reports and dashboards." },
          { n: "Excel Dashboard", p: "₹10,000–30,000", s: "KPIs, data model, charts, filters and management views." },
        ],
      },
      {
        name: "MIS",
        items: [
          { n: "Monthly Business MIS", p: "₹5,000–25,000 / month", s: "Collect, validate, calculate KPIs, prepare report and variance comments." },
          { n: "Sales / Revenue / Expense MIS", p: "₹5,000–20,000 / month", s: "Consolidate transactions, trends, variance and category/customer/product analysis." },
        ],
      },
      {
        name: "Dashboard & Visualisation",
        items: [
          { n: "Power BI Dashboard", p: "₹20,000–60,000", s: "Data preparation, model, measures, visuals, filters, KPIs and handover." },
          { n: "Management KPI Dashboard", p: "₹15,000–50,000", s: "KPI definition, data consolidation, dashboard and reporting cadence." },
        ],
      },
      {
        name: "Business Data Analysis",
        items: [
          { n: "Business Performance Analysis", p: "₹15,000–50,000", s: "Trend, variance, profitability/productivity, drivers, findings and recommendations." },
          { n: "Customer / Product / Vendor Analysis", p: "₹10,000–40,000", s: "Segmentation, comparison, trends, concentration and recommendations." },
        ],
      },
    ],
  },
  {
    id: "05",
    slug: "change-management-and-transformation",
    tag: "Change",
    title: "Change Management & Transformation",
    line: "Guide people and systems through change that actually sticks.",
    image: "svc_change",
    icon: "RefreshCw",
    groups: [
      {
        name: "Change Assessment",
        items: [
          { n: "Change Readiness Assessment", p: "₹20,000–60,000", s: "Stakeholder inputs, readiness, capability gaps, risks and readiness report." },
          { n: "Change Impact Assessment", p: "₹20,000–60,000", s: "Affected teams, processes and systems; impact severity, actions and ownership." },
          { n: "Stakeholder Assessment", p: "₹15,000–40,000", s: "Stakeholder mapping, influence/impact, concerns and engagement approach." },
        ],
      },
      {
        name: "Change Strategy",
        items: [
          { n: "Change Management Strategy", p: "₹30,000–1,00,000", s: "Objectives, stakeholder plan, communication, training, adoption, governance and milestones." },
          { n: "Change Roadmap", p: "₹20,000–75,000", s: "Phases, activities, dependencies, owners, milestones and measures." },
          { n: "Change Communication Plan", p: "₹15,000–50,000", s: "Audience, messages, channels, timing and communication materials." },
        ],
      },
      {
        name: "Employee Change Management",
        items: [
          { n: "Employee Change Readiness", p: "₹15,000–50,000", s: "Readiness communication, concerns, feedback and action plan." },
          { n: "Resistance Management", p: "₹15,000–50,000", s: "Resistance identification, root causes, interventions, escalation and feedback." },
          { n: "Change Workshops", p: "₹10,000–30,000 / session", s: "Awareness, process walkthrough, Q&A, role impact and adoption." },
          { n: "Manager Change Enablement", p: "₹15,000–40,000", s: "Manager briefing, talking points, issue handling, coaching and adoption." },
        ],
      },
      {
        name: "Technology Change",
        items: [
          { n: "HRMS / Payroll Change Management", p: "₹25,000–1,00,000+", s: "Impact assessment, communication, training, adoption, issue tracking and post-go-live support." },
          { n: "Digital Tool Adoption", p: "₹20,000–75,000", s: "User readiness, training, communication, adoption tracking and feedback." },
          { n: "Software Implementation Change Support", p: "₹25,000–1,00,000+", s: "Stakeholder coordination, process transition, training and adoption." },
        ],
      },
      {
        name: "Transformation Support",
        items: [
          { n: "Organisational Transformation Support", p: "₹30,000–1,50,000+", s: "Transformation roadmap, people/process impacts, communication, implementation and monitoring." },
          { n: "Process Transformation", p: "₹25,000–1,00,000+", s: "Current/future state, change impacts, transition, training and adoption." },
          { n: "Post-Implementation Review", p: "₹15,000–50,000", s: "Adoption, issues, benefits, gaps, corrective actions and lessons learned." },
        ],
      },
    ],
  },
  {
    id: "06",
    slug: "brand-and-marketing",
    tag: "Growth",
    title: "Brand & Marketing",
    line: "Positioning, planning and campaigns with consistency.",
    image: "svc_brand",
    icon: "Compass",
    groups: [
      {
        name: "Brand Strategy",
        items: [
          { n: "Brand Positioning", p: "₹15,000–50,000", s: "Audience, value proposition, differentiation, positioning and messaging direction." },
          { n: "Brand Audit", p: "₹15,000–50,000", s: "Brand presence, consistency, messaging, touchpoints and recommendations." },
          { n: "Brand Messaging & Voice", p: "₹10,000–35,000", s: "Key messages, tone, value proposition and messaging framework." },
        ],
      },
      {
        name: "Marketing Planning",
        items: [
          { n: "Marketing Strategy", p: "₹20,000–75,000", s: "Objectives, audience, channels, campaigns, budget, KPIs and action plan." },
          { n: "Marketing Plan & Calendar", p: "₹10,000–35,000", s: "Annual/monthly activities, content, campaigns, owners, dates and KPIs." },
          { n: "Campaign Planning", p: "₹10,000–40,000 / campaign", s: "Objective, audience, offer, channels, content, budget, execution and measurement." },
        ],
      },
      {
        name: "Digital Marketing Coordination",
        items: [
          { n: "Social Media Planning", p: "₹10,000–30,000 / month or project", s: "Content pillars, calendar, ideas, platform coordination and reporting." },
          { n: "WhatsApp Marketing Planning", p: "₹7,500–25,000", s: "Audience segments, campaigns, catalogue/messages, follow-ups and tracking." },
          { n: "Digital Campaign Coordination", p: "₹15,000–50,000 / campaign", s: "Brief, content coordination, scheduling, tracking and campaign report." },
        ],
      },
      {
        name: "Business Content",
        items: [
          { n: "Website & Service Content", p: "₹10,000–50,000", s: "Page structure, service descriptions, FAQs, CTAs and content coordination." },
          { n: "Business Catalogue / Brochure", p: "₹5,000–25,000", s: "Content structure, product/service information and layout-ready copy." },
          { n: "Blog Content Planning", p: "₹5,000–20,000 / month", s: "Topics, themes, calendar, briefs, keyword themes and tracker." },
        ],
      },
      {
        name: "Marketing Analytics",
        items: [
          { n: "Marketing MIS", p: "₹5,000–20,000 / month", s: "Campaign activity, leads, channel performance, content metrics and report." },
          { n: "Marketing Dashboard", p: "₹15,000–50,000", s: "KPIs, campaign data, channel metrics, lead trends and dashboard." },
        ],
      },
    ],
  },
  {
    id: "07",
    slug: "content-and-knowledge",
    tag: "Voice",
    title: "Content & Knowledge",
    line: "Business content, knowledge bases and training material.",
    image: "svc_content",
    icon: "BookOpen",
    groups: [
      {
        name: "Business Content",
        items: [
          { n: "Company Profile", p: "₹5,000–20,000", s: "Company story, services, capabilities, differentiators and business information." },
          { n: "Website Content Package", p: "₹10,000–50,000", s: "Page copy, service descriptions, about, FAQs, CTAs and content structure." },
          { n: "Service / Product Description Pack", p: "₹3,000–25,000", s: "Structured descriptions, benefits, features and FAQs." },
        ],
      },
      {
        name: "Blog & Content Planning",
        items: [
          { n: "Blog Content Calendar", p: "₹5,000–20,000 / month", s: "Topics, themes, titles, briefs, keyword themes and publishing schedule." },
          { n: "Content Research & Planning", p: "₹5,000–25,000 / project", s: "Research, topic clusters, audience needs, briefs and source tracker." },
        ],
      },
      {
        name: "Knowledge Management",
        items: [
          { n: "Knowledge Base Creation", p: "₹15,000–50,000", s: "Categories, articles, FAQs, process references, ownership and maintenance plan." },
          { n: "Internal Knowledge Guide", p: "₹10,000–35,000", s: "Role/process information, quick references, FAQs, escalation and handover." },
        ],
      },
      {
        name: "Training Content",
        items: [
          { n: "Training Manual", p: "₹10,000–40,000", s: "Objectives, modules, instructions, examples, exercises and assessment." },
          { n: "Training Workbook / Material", p: "₹5,000–25,000", s: "Exercises, worksheets, checklists, evaluation and facilitator notes." },
        ],
      },
      {
        name: "Business Communication",
        items: [
          { n: "Business Communication Template Pack", p: "₹3,000–15,000", s: "Customer emails, announcements, follow-ups, reminders, complaint responses and internal messages." },
        ],
      },
    ],
  },
  {
    id: "08",
    slug: "admin-and-operations-support",
    tag: "Operations",
    title: "Admin & Operations Support",
    line: "Streamlined admin, vendor, client and office operations.",
    image: "svc_admin",
    icon: "ClipboardList",
    groups: [
      {
        name: "Business Administration",
        items: [
          { n: "Business Admin Setup", p: "₹10,000–35,000", s: "Admin workflows, registers, checklists, responsibilities and document control." },
          { n: "Admin Support", p: "₹5,000–25,000 / month", s: "Records, trackers, renewals, coordination, routine administration and reporting." },
          { n: "Document & Renewal Register", p: "₹2,500–10,000", s: "Register, expiry dates, ownership, reminders and status tracking." },
        ],
      },
      {
        name: "Vendor & Purchase Management",
        items: [
          { n: "Vendor Management Setup", p: "₹7,500–25,000", s: "Vendor master, categories, evaluation, contacts, documents and review process." },
          { n: "Purchase & Vendor Tracker", p: "₹3,000–15,000", s: "Purchase requests, orders, vendors, payments and status." },
          { n: "Vendor Evaluation System", p: "₹5,000–20,000", s: "Criteria, scorecard, review form, performance tracker and recommendations." },
        ],
      },
      {
        name: "Customer & Client Administration",
        items: [
          { n: "Client Management System", p: "₹7,500–25,000", s: "Client master, onboarding, communication, follow-up, renewals and complaints." },
          { n: "Client Onboarding Kit", p: "₹5,000–20,000", s: "Information form, document checklist, welcome communication, workflow and handover." },
        ],
      },
      {
        name: "Office Operations",
        items: [
          { n: "Office Operations Kit Setup", p: "₹10,000–35,000", s: "Assets, inventory, maintenance, utilities, stationery, checklists and registers." },
          { n: "Asset & Inventory Management", p: "₹5,000–20,000", s: "Asset register, stock, issue/return, verification, maintenance and reporting." },
          { n: "AMC / Maintenance Tracker", p: "₹3,000–10,000", s: "Contracts, vendors, expiry, service dates, costs and status." },
        ],
      },
      {
        name: "Management Administration",
        items: [
          { n: "Meeting & Action Management", p: "₹3,000–15,000", s: "Agenda, minutes, decisions, action owners, deadlines and follow-up." },
          { n: "Management Reporting Support", p: "₹5,000–25,000 / month", s: "Collect updates, consolidate, KPI/status reporting, action tracker and summary." },
        ],
      },
    ],
  },
  {
    id: "09",
    slug: "website-and-digital-business",
    tag: "Digital",
    title: "Website & Digital Business",
    line: "Plan, structure and maintain your digital presence.",
    image: "svc_digital",
    icon: "Globe",
    groups: [
      {
        name: "Website Planning",
        items: [
          { n: "Website Structure Planning", p: "₹10,000–35,000", s: "Sitemap, pages, navigation, user journey and content requirements." },
          { n: "Website Content Structure", p: "₹10,000–40,000", s: "Page objectives, sections, headings, CTAs, FAQs and content checklist." },
        ],
      },
      {
        name: "Website Content & Management",
        items: [
          { n: "Website Content Management", p: "₹5,000–25,000 / month", s: "Page, service/product, blog and FAQ updates and housekeeping." },
          { n: "Product / Service Upload", p: "₹20–100 / item or project fee", s: "Formatting, categorisation, descriptions, images/files, upload and quality check." },
          { n: "Website Housekeeping", p: "₹5,000–20,000 / month", s: "Content checks, incomplete pages, menus, forms, updates and issue log." },
        ],
      },
      {
        name: "WordPress & Digital Administration",
        items: [
          { n: "WordPress Administration Support", p: "₹5,000–25,000 / month", s: "Page/content updates, media, menus, posts and basic administration." },
          { n: "Website Audit", p: "₹10,000–35,000", s: "Content, structure, usability, basic SEO, forms and recommendations." },
          { n: "WhatsApp Business Setup", p: "₹3,000–10,000", s: "Profile, catalogue structure, quick replies, labels and customer workflow." },
          { n: "Google Business Profile Support", p: "₹3,000–10,000", s: "Profile setup/optimisation, business information, categories and content guidance." },
          { n: "IndiaMART / Directory Support", p: "₹3,000–15,000", s: "Profile information, listings, enquiry workflow and optimisation." },
        ],
      },
    ],
  },
  {
    id: "10",
    slug: "hr-tech-business-tech-and-automation",
    tag: "Automation",
    title: "HR Tech, Business Tech & Automation",
    line: "Advisory, implementation and Excel/workflow automation.",
    image: "svc_tech",
    icon: "Cpu",
    groups: [
      {
        name: "HR Technology",
        items: [
          { n: "HR Technology Advisory", p: "₹10,000–30,000", s: "Requirements, options, comparison, process fit and implementation considerations." },
          { n: "HR Technology Audit", p: "₹15,000–50,000", s: "Tools, process fit, data, adoption, gaps and improvement plan." },
          { n: "HRMS / Payroll Implementation Support", p: "₹20,000–75,000+", s: "Setup support, data preparation, configuration, testing, training and go-live assistance." },
        ],
      },
      {
        name: "Excel & Business Automation",
        items: [
          { n: "HR / Business Tracker Automation", p: "₹10,000–40,000", s: "Automated trackers, formulas, validations, summaries and dashboards." },
          { n: "Automated Reporting System", p: "₹15,000–50,000", s: "Data input, calculations, report templates, refresh workflow and management output." },
          { n: "Automation Opportunity Assessment", p: "₹15,000–50,000", s: "Manual-work mapping, repetitive-task analysis, prioritisation, tool recommendations and roadmap." },
          { n: "Digital Workflow Design", p: "₹15,000–60,000", s: "Forms, approvals, notifications, handoffs, data capture and reporting." },
        ],
      },
    ],
  },
  {
    id: "11",
    slug: "training-and-learning",
    tag: "Learning",
    title: "Training & Learning",
    line: "Corporate training, material and induction programmes.",
    image: "svc_training",
    icon: "GraduationCap",
    groups: [
      {
        name: "Corporate Training",
        items: [
          { n: "HR / Payroll Training", p: "₹5,000–20,000 / session", s: "Concepts, process walkthrough, practical exercises, Q&A and references." },
          { n: "Excel / MIS Training", p: "₹5,000–25,000 / session", s: "Data preparation, formulas, pivots, dashboards, reporting and exercises." },
          { n: "Process / SOP Training", p: "₹5,000–20,000 / session", s: "Process explanation, SOP walkthrough, roles, controls and scenarios." },
        ],
      },
      {
        name: "Training Material Development",
        items: [
          { n: "Training Presentation", p: "₹5,000–20,000 / deck", s: "Objectives, structured content, examples, exercises and facilitator notes." },
          { n: "Training Programme Pack", p: "₹15,000–50,000", s: "Agenda, presentation, workbook, attendance, feedback, assessment and completion report." },
        ],
      },
      {
        name: "Employee & Manager Training",
        items: [
          { n: "Employee Induction Programme", p: "₹10,000–35,000", s: "Company orientation, HR policies, processes, systems and expectations." },
          { n: "Manager Training Programme", p: "₹15,000–50,000", s: "People management, performance, interviewing, communication, HR processes and change." },
        ],
      },
    ],
  },
  {
    id: "12",
    slug: "fractional-and-outsourced-support",
    tag: "On-Demand",
    title: "Fractional & Outsourced Support",
    line: "Ongoing HR, payroll, MIS and process support on retainer.",
    image: "svc_fractional",
    icon: "Handshake",
    groups: [
      {
        name: "Fractional HR",
        items: [
          { n: "Fractional HR Support", p: "₹15,000–60,000 / month", s: "HR administration, employee support, recruitment coordination, policies, HR MIS and management support." },
        ],
      },
      {
        name: "Payroll Outsourcing",
        items: [
          { n: "Outsourced Payroll", p: "₹10,000–60,000+ / month", s: "End-to-end payroll, attendance, leave, payslips, payroll reports and statutory coordination." },
        ],
      },
      {
        name: "Outsourced HR Operations",
        items: [
          { n: "Outsourced HR Operations", p: "₹20,000–75,000+ / month", s: "Employee records, onboarding, HR documentation, attendance/leave, queries and HR MIS." },
        ],
      },
      {
        name: "Business Process Support",
        items: [
          { n: "Ongoing Process & MIS Support", p: "₹15,000–60,000 / month", s: "Process administration, trackers, SOP implementation, workflow coordination and management reporting." },
        ],
      },
    ],
  },
];

export const PRODUCTS = [
  { name: "HR Starter Bundle", shop: "HR Product Shop", price: "₹1,999 – ₹4,999", includes: "HR Starter Kit, Employee Master, Joining/Exit Checklists, Attendance, Leave and HR Forms.", img: "/images/products/hr-starter.png" },
  { name: "Recruitment Bundle", shop: "HR Product Shop", price: "₹1,499 – ₹3,999", includes: "Recruitment Kit, Tracker, MIS, JD Templates, Interview Forms and Checklist.", img: "/images/products/recruitment.png" },
  { name: "Payroll & Compensation Bundle", shop: "HR Product Shop", price: "₹2,499 – ₹7,500", includes: "CTC Calculator, Salary Structure, Payroll Workbook, Checklist, Reconciliation, F&F Calculator and Payroll MIS.", img: "/images/products/payroll.png" },
  { name: "HR Policy Bundle", shop: "HR Product Shop", price: "₹1,999 – ₹5,999", includes: "HR Policy Pack, Employee Handbook, Leave, Attendance, WFH, Code of Conduct, Travel and Expense.", img: "/images/products/policy.png" },
  { name: "HR MIS & Dashboard Bundle", shop: "HR Product Shop", price: "₹2,499 – ₹7,500", includes: "Headcount, Attrition, Recruitment, Leave, Attendance and Payroll dashboards.", img: "/images/products/dashboard.png" },
  { name: "Brand Starter Bundle", shop: "Brand & Marketing Shop", price: "₹999 – ₹3,999", includes: "Brand Audit, Positioning, USP, Messaging and Voice Guide.", img: "/images/products/marketing.png" },
  { name: "Marketing Starter Bundle", shop: "Brand & Marketing Shop", price: "₹999 – ₹3,999", includes: "Marketing Planner, Calendar, Campaign Planner, Content Calendar and KPI Tracker.", img: "/images/products/marketing.png" },
  { name: "Business Data Starter Kit", shop: "Data & BI Shop", price: "₹999 – ₹3,999", includes: "Data Collection, Cleaning, Master Data, Validation and Data Dictionary.", img: "/images/products/dashboard.png" },
  { name: "Business MIS Bundle", shop: "Data & BI Shop", price: "₹1,499 – ₹4,999", includes: "Sales, Revenue, Expense, Customer MIS and Management Report.", img: "/images/products/dashboard.png" },
  { name: "Business Process Starter Kit", shop: "Process Shop", price: "₹999 – ₹3,999", includes: "Process Mapping, Audit, Gap Analysis, Workflow and Improvement Tracker.", img: "/images/products/process.png" },
  { name: "SOP Professional Kit", shop: "Process Shop", price: "₹1,499 – ₹4,999", includes: "SOP Template, Register, Version Control, Approval Tracker and Audit Checklist.", img: "/images/products/process.png" },
  { name: "Small Business Management Kit", shop: "Process Shop", price: "₹1,999 – ₹5,999", includes: "Business Planner, Goal Tracker, Organisation Chart, RACI, Action Tracker and Business Review.", img: "/images/products/process.png" },
  { name: "Business Content Bundle", shop: "Content Shop", price: "₹999 – ₹3,999", includes: "Company Profile, About Us, Service Descriptions, FAQ and Website Content Planner.", img: "/images/products/content.png" },
  { name: "Knowledge Management Bundle", shop: "Content Shop", price: "₹1,499 – ₹4,999", includes: "Knowledge Base, FAQ Database, Process Knowledge, Knowledge Transfer and Internal Guide.", img: "/images/products/content.png" },
  { name: "Office Admin Starter Kit", shop: "Admin & Ops Shop", price: "₹999 – ₹3,999", includes: "Admin Checklist, Asset Register, Vendor Register, Expense Tracker and Maintenance Tracker.", img: "/images/products/admin.png" },
  { name: "Operations Management Kit", shop: "Admin & Ops Shop", price: "₹1,499 – ₹4,999", includes: "Operations Tracker, Task Tracker, Process Checklist, Issue Tracker, Action Tracker and Management Review.", img: "/images/products/admin.png" },
  { name: "Complete Small Business HR Toolkit", shop: "HR Product Shop", price: "₹7,500 – ₹15,000+", includes: "A comprehensive bundle covering major HR product families.", img: "/images/products/hr-starter.png" },
];

export const WAYS = [
  { name: "Project based", line: "Fixed pricing for a defined scope", icon: "Briefcase", price: "" },
  { name: "Monthly retainer", line: "Ongoing HR, payroll, MIS & ops support", icon: "RefreshCw", price: "" },
  { name: "Hourly consulting", line: "Senior advice, billed by the hour", icon: "Clock", price: "₹2,500 – ₹7,500 / hour" },
  { name: "Daily consulting", line: "Dedicated on-site or remote days", icon: "CalendarDays", price: "₹15,000 – ₹35,000 / day" },
];

export const MARQUEE_ITEMS = [
  "HR & Payroll",
  "Process Consulting",
  "Data, MIS & BI",
  "Brand & Marketing",
  "Change Management",
  "Digital Products",
  "Training & Learning",
  "Fractional Support",
];
